import { localize } from "render/context/InternationalizationContext";

export const Trans = {
  Title: localize({
    en_GB: <>Data & Privacy</>,
    sv_SE: <>Data & Integritet</>,
  }),
  Paragraph: localize({
    en_GB: (
      <>
        Your health data helps us develop our tools so we can find and stop
        diseases before they start. In order to get a Neko Body Scan, we need
        your consent to participate in our clinical studies.
        <br />
        <br />
        You can read more about how we treat these in the clinical studies
        listed below. Participation is completely voluntary, and you can cancel
        your participation at any time, even after you have given consent.
      </>
    ),
    sv_SE: (
      <>
        Vi på Neko använder dina hälsouppgifter för att utveckla våra verktyg så
        vi kan hitta sjukdomar ännu snabbare och bättre. För att göra en Neko
        Body Scan behöver vi ditt samtycke till behandlingen av dina personliga
        hälsouppgifter till våra kliniska studier.
        <br />
        <br />
        Du kan läsa mer om hur vi behandlar dessa i de kliniska studierna
        listade nedan. Deltagande är helt frivilligt och du kan avbryta ditt
        deltagande när som helst, även efter att du skrivit på samtycket.
      </>
    ),
  }),
  ClinicalStudies: localize({
    en_GB: <>Clinical Studies</>,
    sv_SE: <>Kliniska Studier</>,
  }),
  Other: localize({
    en_GB: <>Other</>,
    sv_SE: <>Övrigt</>,
  }),
  PatientJournal: localize({
    en_GB: <>Journal</>,
    sv_SE: <>Journal</>,
  }),
};
